module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-wrapper"
  }, [_c('section', {
    staticClass: "content-header"
  }, [_c('h1', [_vm._v("\n      " + _vm._s(_vm.getDatasetDisplayType(_vm.dataSetType)) + " Extraction Accuracy\n    ")]), _vm._v(" "), _c('ol', {
    staticClass: "breadcrumb"
  }, [_vm._m(0), _vm._v(" "), _c('li', {
    staticClass: "active"
  }, [_vm._v(_vm._s(_vm.getDatasetDisplayType(_vm.dataSetType)) + " Evaluate")])])]), _vm._v(" "), _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "file-display-div"
  }, [_c('strong', [_vm._v("File name: ")]), _vm._v(_vm._s(_vm.fileName) + "\n            "), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Gender count: ")]), _vm._v(" Women - " + _vm._s(_vm.womenCount) + ", Men - " + _vm._s(_vm.menCount) + "\n          ")]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "col-xs-12 col-md-12 col-lg-12 audit-tree-select"
  }, [_c('vue-good-table', {
    attrs: {
      "styleClass": "vgt-table good-table condensed striped",
      "columns": _vm.columns,
      "rows": _vm.evaluatedData,
      "pagination-enabled": false
    },
    scopedSlots: _vm._u([{
      key: "table-row",
      fn: function(props) {
        return [_vm._t("default", null, {
          "props": props
        }), _vm._v(" "), (props.column.field === 'gender') ? _c('span', {
          staticClass: "bold-text"
        }, [_vm._v(_vm._s(props.formattedRow[props.column.field]))]) : _c('span', [_vm._v(_vm._s(parseFloat(props.formattedRow[props.column.field].toFixed(3))) + "%")])]
      }
    }], null, true)
  }, [_c('div', {
    attrs: {
      "slot": "emptystate"
    },
    slot: "emptystate"
  }, [_c('nv-empty-state', {
    attrs: {
      "icon": "fa-check-square-o",
      "title": "Nothing to evaluate",
      "hint": "There are no records in this dataset yet."
    }
  })], 1), _vm._v(" "), _c('template', {
    slot: "loadingContent"
  })], 2)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "audit-save-btn"
  }, [_c('router-link', {
    attrs: {
      "to": ("/auditing/" + _vm.dataSetType)
    }
  }, [_c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "margin": "30px 0px"
    },
    attrs: {
      "type": "button"
    }
  }, [_vm._v("Go back")])])], 1)])])])]), _vm._v(" "), (_vm.loading) ? _c('BlockUI', [_c('i', {
    staticClass: "fa fa-cog fa-spin fa-3x fa-fw"
  }), _c('br'), _vm._v("Please wait...")]) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "fa fa-dashboard"
  }), _vm._v(" Home")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-09ad0f8e","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/auditing/evaluate.vue
// module id = Jdqf
// module chunks = 1